import * as React from 'react';
import { useState, useRef, forwardRef, useImperativeHandle } from 'react';
import {Modal} from "ctls/modal/Modal";
import styled from "styled-components";
import clsx from "clsx";
import {SsqImages} from "images/SsqImages";
import {formatDate, formatDateTime} from "util/formatDateTime";
import img_view_icon_smile from "images/common/icon_smile_16.svg";
import img_view_icon_angry from "images/common/icon_angry_16.svg";
import img_view_icon_alarm from "images/common/icon_feed_alarm.svg";
import {getFeedbackTypeLangKey2} from "definitions/FeedbackType";
import {Overlay} from "borispage/common/AdminCommonComponents";
import {IFeedbackInfo} from "repositories/SsqDataRepository";
import svcs from "services";
import {admin_popup} from "style/CommonStyledComponents";
import {fontFamilyBold} from "style/fonts";
import {IfSsqDataDocumentEntity, SsqDataDocumentEntity} from "models/IfSsqDataDocumentEntity";
import axios from 'axios';


type Props = {};

type ShowResult = { cmd: string };

export interface PopFeedbackListRef {
  show: (param: { docId: number }) => Promise<ShowResult>;
}

/**
 * 신고하기 팝업.
 */
export const PopFeedbackList = forwardRef<PopFeedbackListRef, Props>((props, ref) => {
  const [visible, setVisible] = useState(false);
  const [docId, setDocId] = useState<number | null>(null);
  const [doc, setDoc] = useState<IfSsqDataDocumentEntity>(new SsqDataDocumentEntity());
  const [feedbackList, setFeedbackList] = useState<IFeedbackInfo[]>([]);
  const [showMailPopup, setShowMailPopup] = useState(false);
  const [idFeedbackWriter, setIdFeedbackWriter] = useState(0);
  const [idFeedbackChecker, setIdFeedbackChecker] = useState(0);

  const resolveRef = useRef<((value: ShowResult) => void) | null>(null);
  const rejectRef = useRef<((reason?: any) => void) | null>(null);

  const getInitData = (docId: number) => {
    console.log("docid ", docId);
    Promise.all([
      axios.get("/api/boris/ssqData/document/entity/" + docId),
      svcs.repoSsqData.getFeedbacksByDocumentId(docId)
    ]).then(([res, list]) => {
      console.log('res', res.data, ' list ', list);
      setDoc(res.data);
      setFeedbackList(list);
      setDocId(docId);
    }).catch(e => console.error("E", e));
  };

  useImperativeHandle(ref, () => ({
    show: (param: { docId: number }) => {
      return new Promise<ShowResult>((resolve, reject) => {
        resolveRef.current = resolve;
        rejectRef.current = reject;
        setVisible(true);
        setDocId(param.docId);
        setFeedbackList([]);
        setShowMailPopup(false);
        setIdFeedbackWriter(0);
        setIdFeedbackChecker(0);
        setDoc(new SsqDataDocumentEntity());
        if (param.docId > 0) getInitData(param.docId);
      });
    },
  }));

  const doResolve = (res: ShowResult) => {
    setVisible(false);
    if (resolveRef.current) {
      resolveRef.current(res);
    }
  };

  const doReject = (res: ShowResult) => {
    setVisible(false);
    if (rejectRef.current) {
      rejectRef.current(res);
    }
  };

  const handleClick = (e: React.MouseEvent, cmd: string, param?: any) => {
    console.log("cmd is ", cmd);
    if (e && e.preventDefault) e.preventDefault();
    if (cmd === 'cancel' || cmd == 'close') {
      doReject({cmd});
    } else if (cmd === 'send-email') {
      // TODO: implement if needed
    } else {
      console.error("unknown cmd ", cmd, " param ", param);
    }
  };

  const trans = (key: string): string => {
    svcs.svcLang.setNamespace("I18N_NAMESPACE_ADMIN_PAGE");
    return svcs.svcLang.getTranslationByKey(key) || "";
  };

  const closeTermsDetailPopup = () => {
    doResolve({cmd: 'close'});
  };

  return (<>
      {visible ? (<Modal>
        <PopBase>
          <PopCnts className={clsx("ssq-center ")}>
            <div className={"feedbackPopup"}>
              <div className={"popup-top"}>
                <h2>{trans("I18N_FEEDBACK_OF_DOCUMENT")}</h2>
                <button className={"close-button"} onClick={() => closeTermsDetailPopup()}
                >
                  <img alt={"close_small_icon.svg"} src={SsqImages.common.icon.closeSmallIcon()}/>
                </button>
              </div>
              <div className={"popup-content"}>
                <div className={"feedback_doc"}>
                  <div className={"tit"}>{doc.docTitle || ""}</div>
                  <div className={"info"}>
                    {(showMailPopup) && <ShowMailPopupComponent emailAddress={doc.writerId}/>}
                    <p className="flex align-middle">
                      <span className={"info_name"}
                        onClick={() => {
                          setShowMailPopup(!showMailPopup);
                          setIdFeedbackWriter(0);
                          setIdFeedbackChecker(0);
                        }}>{doc.writerNickname || ""}</span>
                      <span className={"info_data"}>{doc.updateTime && formatDateTime(new Date(doc.updateTime))}</span>
                    </p>
                    <p className={clsx("td-icon")}>
                      <img src={img_view_icon_smile} alt=""/><span className="txt-blue">{doc.goodCount || 0}</span>
                      <img src={img_view_icon_angry} alt=""/><span className="txt-red">{doc.badCount || 0}</span>
                      <img src={img_view_icon_alarm} alt=""/><span className="txt-red">{doc.reportedCnt || 0}</span>
                    </p>
                  </div>
                </div>
                <div className={"feedback_list"}>
                  {feedbackList.map((feedback, index) => {
                    return <div key={index} className={"feedback_list_item"}>
                      <div className={"info"}>
                        <span
                          className={(feedback.feedbackType === 'GOOD') ? "txt-blue" : "txt-red"}>{trans(getFeedbackTypeLangKey2(feedback.feedbackType))}</span>
                        <span className={"info_name"}
                          onClick={() => {
                            let feedbackId = 0;
                            if (idFeedbackWriter !== feedback.feedbackId) {
                              feedbackId = feedback.feedbackId;
                            }
                            setShowMailPopup(false);
                            setIdFeedbackWriter(feedbackId);
                            setIdFeedbackChecker(0);
                          }}>{feedback.feedbackWriterNickname}</span>
                        {(idFeedbackWriter === feedback.feedbackId) &&
                          (feedback.feedbackWriterId !== 'GUEST') && <ShowMailPopupComponent emailAddress={feedback.feedbackWriterId}/>}
                        <span className={"info_data"}>{formatDate(new Date(feedback.feedbackDate))}</span>
                      </div>
                      <div className={"com"}>{feedback.comment}</div>
                      {feedback.checked &&
                        <div className={"info_chk"}>
                          <img src={SsqImages.boris.feedbackCheck()} alt={"feedback_check.svg"}/>
                          <span className={"info_name"}
                            onClick={() => {
                              let feedbackId = 0;
                              if (idFeedbackChecker !== feedback.feedbackId) {
                                feedbackId = feedback.feedbackId;
                              }
                              setShowMailPopup(false);
                              setIdFeedbackWriter(0);
                              setIdFeedbackChecker(feedbackId);
                            }}>{feedback.checkerNickname}</span>
                          {(idFeedbackChecker === feedback.feedbackId) && <ShowMailPopupComponent emailAddress={feedback.checkerId}/>}
                          <span className={"info_data"}>{formatDate(new Date(feedback.checkDate))}</span>
                        </div>}
                    </div>;
                  })}
                </div>
              </div>
              {(showMailPopup || idFeedbackWriter !== 0 || idFeedbackChecker !== 0) &&
                <Overlay className={"Feedback_overlay"} aria-label={"popup-overlay"}
                  onClick={() => {
                    setShowMailPopup(false);
                    setIdFeedbackWriter(0);
                    setIdFeedbackChecker(0);
                  }}/>}
            </div>
          </PopCnts></PopBase>
      </Modal>) : null}
    </>
  );
});

PopFeedbackList.displayName = 'PopFeedbackList';


const ShowMailPopupComponent = ({emailAddress}: {emailAddress: string}) => {
  return <div className={"float_wrap"}>
    <a href={`mailto:${emailAddress}`} target="_blank">{emailAddress}
      <img src={SsqImages.boris.feedbackMail()}/></a>
  </div>;
};

export const PopBase = styled.div`
  .Feedback_tit {
    font-size: 1.2rem;
    color: #7783A1;
    line-height: 3.2rem;
    margin-bottom: 1.5rem;


    .num {
      color: #407EDB;
      margin-left: .8rem
    }


    .Feedback_chk {
      color: #2A2C2F;
      margin-left: 10rem;
      display: inline-block;
    }

    .post-button {
      float: right;
      width: 8rem !important;
      font-size: 1.2rem !important;
      height: 3.2rem !important;
      line-height: 3.2rem !important;
    }
  }


  .gray_tr {
    color: #7783A1;

    td.txt-blue, td.txt-red {
      color: #7783A1 !important;
    }
  }

  tr {
    &:hover {
      background: rgba(64, 125, 217, 0.1) !important;
    }

    &:active {
      background: rgba(64, 125, 217, 0.3) !important;
    }
  }

  tbody td {
    vertical-align: baseline;
    cursor: pointer;
    padding: 1.2rem 0.4rem;
  }

  .td_title {
    display: revert;
    white-space: initial;
    text-overflow: inherit;
    overflow: inherit;
    height: auto;
    padding: 1rem .4rem;
    line-height: 2rem
  }

  .td_pop {
    cursor: pointer;
  }

  .float_wrap {
    background: #fff;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.2);
    border-radius: 4px;
    position: absolute;
    margin: -5px 0 0 10px;
    z-index: 1003;

    a {
      display: block;
      color: #2A2C2F;
      padding: 1rem 1.6rem;
    }

    img {
      vertical-align: middle;
      margin-left: .8rem;
    }
  }

  .td_file {
    color: #407EDB !important;
    ${fontFamilyBold}
  }

  .td_back {

    * {
      vertical-align: middle;
    }

    > img {
      margin-right: 1.6rem;
      cursor: pointer;
    }

    .feedback_ico {
      display: inline-block;

      > span {
        width: 50px;
        display: inline-block;
      }
    }
  }

  .overlay {
    cursor: default
  }

  .td-icon > img {
    margin-right: .4rem;
    vertical-align: middle;
  }

  .td-icon > span {
    margin-right: .4rem;
  }


  .Feedback_overlay {
    background: none;
  }
`;

export const PopCnts = styled.div`
  ${admin_popup};
  height: 64rem;
  z-index: 1004;
  cursor: default;

  .feedbackPopup {
    height: 100%;
    line-height: initial;

    .popup-top {
      padding: 2rem 1.6rem;

      h2 {
        font-size: 2.4rem;
        font-weight: 700;
      }

      .close-button {
        right: 2rem;
        top: 2rem;
      }
    }

    .popup-content {
      height: calc(100% - 3rem);
      padding: 0;

      .feedback_doc {
        background: #F7F8FB;
        border-top: 1px solid #DDE2E9;
        border-bottom: 1px solid #DDE2E9;
        padding: 1.2rem 2.4rem;
        margin-bottom: 1.2rem;

        .tit {
          font-size: 1.4rem;
          line-height: 2.4rem;
          color: #407EDB;
          margin-bottom: .4rem;
          ${fontFamilyBold}
        }

        .info {
          display: flex;
          justify-content: space-between;
          line-height: 2.4rem;

          .info_name {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            display: inline-block;
            //width: 40%;
            cursor: pointer;
            margin-right: 1rem;
          }

          .info_data {
            font-size: 1rem;
            color: #7783A1;
            margin-left: .4rem;
          }
        }
      }

      .feedback_list {
        height: calc(100% - 14.8rem);
        overflow-y: auto;
        padding: 0 2.4rem;

        .feedback_list_item {
          padding: 1.2rem 0;
          border-bottom: 1px solid #EEF1F6;
          position: relative;

          .info {
            line-height: 2.4rem;
          }

          .info_name {
            margin-left: .9rem;
            cursor: pointer;
          }

          .info_data {
            font-size: 1rem;
            color: #7783A1;
            margin-left: .6rem;
          }

          .com {
            font-size: 1.4rem;
            margin: .4rem 0;
            white-space: initial;
          }

          .info_chk {
            text-align: right;
            line-height: 2.3rem;

            img {
              vertical-align: middle;
            }

            .float_wrap {
              right: 0;
            }
          }

          &:last-child {
            border-bottom: none;
          }
        }
      }
    }
  }

  @media screen and (max-width: 764px) {
    width: 100%;
    overflow: hidden;
    height: 100%;
  }
  @media screen and (max-width: 360px) {
    height: 100vh;
    min-height: 100vh;
    min-height: -webkit-fill-available;

  }
`;
